import React from 'react';
import { Platform, View } from 'react-native';
import Dimens from 'src/core/utils/Dimens';
import Colors from 'src/core/utils/Colors';

interface DividerProps {
	bordered?: boolean;
	bgColor?: string;
	paddingTop?: number;
	paddingBottom?: number;
	height?: number;
}

export default function Divider({ bordered = false, bgColor, paddingTop, paddingBottom, height }: DividerProps) {
	return Platform.OS === 'ios' ? (
		<View
			style={{
				backgroundColor: bgColor ?? Colors.greyBg,
				paddingTop: paddingTop ?? 12,
				paddingBottom: paddingBottom ?? 10,
				height: height ?? 35,
			}}
		/>
	) : (
		<View
			style={{
				backgroundColor: Colors.overlay12,
				marginTop: 11,
				marginBottom: Dimens.margin8,
				paddingTop: Dimens.padding0,
				paddingBottom: Dimens.padding0,
				height: 1,
			}}
		/>
	);
}
